import { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { PartCardSmall } from '@qb/frontend/components/PartCards/PartCardSmall';
import { BaseCarousel } from '@/components/Common/BaseCarousel/BaseCarousel';
import { useRequestPartPriceFromSPW } from '@/hooks/useRequestPartPriceFromSPW';
import { TenantConfig } from '@/shared/types/controllers/sps/SPSAppControllerTypes';
import { PartGetRecentlyViewedParts } from '@/shared/types/controllers/sps/SPSPartControllerTypes';

// TODO: Consider fetching this from an API or configuration
const SHIP_PROCESSING_DAYS = 0;
type RecentlyViewedProductsCarouselProps = {
  tenantConfig: TenantConfig;
  parts: PartGetRecentlyViewedParts['parts'];
};
export const RecentlyViewedProductsCarousel = ({
  tenantConfig,
  parts
}: RecentlyViewedProductsCarouselProps) => {
  const {
    requestMultiplePartsPrices,
    getPartPrice
  } = useRequestPartPriceFromSPW();
  useEffect(() => {
    const partIDs = parts.map(({
      id
    }) => id);

    /**
     * Request the prices for the parts carousel.
     */
    requestMultiplePartsPrices(partIDs);
  }, [getPartPrice, parts, requestMultiplePartsPrices]);
  const partsWithDiscounts = parts.map(part => {
    const partPrice = getPartPrice(part.id);
    return {
      ...part,
      price: partPrice?.price ?? undefined,
      originalPrice: partPrice?.originalPrice ?? undefined,
      shipProcessingDays: SHIP_PROCESSING_DAYS
    };
  });

  // This is the minimum so it doesn't look so ugly
  if (parts.length < 3) {
    return null;
  }
  return <Box sx={{
    bgcolor: 'common.backgroundColor',
    py: 3
  }} data-sentry-element="Box" data-sentry-component="RecentlyViewedProductsCarousel" data-sentry-source-file="RecentlyViewedProductsCarousel.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="RecentlyViewedProductsCarousel.tsx">
        <Typography variant="h4" component="h2" sx={{
        mb: 3
      }} data-sentry-element="Typography" data-sentry-source-file="RecentlyViewedProductsCarousel.tsx">
          Recently viewed products
        </Typography>
        <Box data-sentry-element="Box" data-sentry-source-file="RecentlyViewedProductsCarousel.tsx">
          <BaseCarousel slidesCount={partsWithDiscounts.length} slidesToShow={{
          xs: 1.5,
          sm: 2,
          md: 3,
          lg: 4,
          xl: 4
        }} data-sentry-element="BaseCarousel" data-sentry-source-file="RecentlyViewedProductsCarousel.tsx">
            {partsWithDiscounts.map(part => <Box key={part.id} sx={{
            px: 1
          }}>
                <PartCardSmall tenantConfig={tenantConfig} part={part} />
              </Box>)}
          </BaseCarousel>
        </Box>
      </Container>
    </Box>;
};